<template>
  <div class="conmon-top bind-pub-num">
    <div class="bind-pub-num-tips">
      <span>公众号绑定受众类型后，通过公众号收集的客户信息，会作为新的受众记录，显示在对应的受众类型菜单下。授权微信前必须先绑定受众类型。</span>
    </div>
    <div class="model-content base-dialog">
      <el-form ref="editForm" :model="form" :rules="rules">
        <el-form-item label="绑定受众类型:" :label-width="addLabelWidth" prop="modelId">
          <el-select class="common-search-formtype" style="margin-right: 13px;" v-model="form.modelId"
            placeholder="请选择受众类型">
            <el-option v-for="item in models" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
    </div>
    <div class="next-content">
      <a @click="next" class="next-btn">下一步</a>
    </div>
  </div>
</template>

<script>
import { publicNumber, startOrStopPublic, setDefaultPublicNum } from '@/api/customer.js'
import { getCusTypes } from '@/api/set.js'
import { API_HOST } from '../../api/local'

export default {
  name: 'publicNumber',
  data () {
    return {
      rules: {
        modelId: [
          { required: true, message: '请选择受众类型', trigger: 'change' }
        ]
      },
      form: {
        modelId: ''
      },
      models: [],
      addLabelWidth: '120px',
      loading: true,
      tableData: [],
      originalId: '',
      isDisabled: false,
      defaultDisabled: false
    }
  },
  mounted () {
    this.getData()
  },
  methods: {
    getData () {
      this.loading = true
      getCusTypes().then((res) => {
        if (res.data.code == 200) {
          this.models = res.data.result
        }
      })
      this.openLoading()
    },
    next () {
      if (this.form.modelId === '') {
        _g.toastMsg('error', '请选择受众类型')
        return
      }
      window.location.href = this.openUrl
    },
    // 数据加载时的动画
    openLoading () {
      setTimeout(() => {
        this.loading = false
      }, 500)
    }
  },
  computed: {
    openUrl () {
      let userInfo = Lockr.get('userInfo')
      return API_HOST + 'wechat/ez_open_platform/getRequestCodeURL?uid=' + userInfo.id + '&modelId=' + this.form.modelId +
        '&referer=' + window.location.protocol + '//' + window.location.host + '/home/public-number'
    }
  },
  created () {
  }
}
</script>

<style scoped>
.bind-pub-num {
  width: calc(100% - 40px);
  height: 100%;
  margin: 20px auto;
  background: #fff;
}
.bind-pub-num-tips {
  width: calc(100% - 60px);
  margin: 20px auto 0;
  text-align: left;
  padding-top: 20px;
}
.model-content {
  width: 520px;
  margin: 220px auto 0;
}
.next-btn {
  display: inline-block;
  padding: 7px 17px;
  background: #1890FF;
  color: #fff;
  cursor: pointer;
  border-radius: 4px;
  margin-top: 100px;
}
.sign-manage-title {
  background: #ecf6ff;
  border: 1px solid #e4e4e4;
  height: 60px;
  padding: 10px;
  line-height: 40px;
  margin-top: 10px;
}
.green {
  color: green;
}
.red {
  color: red;
}
.authorization-btn {
  padding: 2px 10px;
  border-radius: 20px;
  text-align: center;
  line-height: 30px;
  float: right;
  display: block;
  color: #fff;
  font-size: 14px;
  background: #4882ff;
  margin-top: 8px;
  margin-right: 13px;
  cursor: pointer;
}
.table-title {
  text-align: left;
}
.dialog-content {
  height: 200px;
}
.content-one span {
  display: inline-block;
  float: left;
  line-height: 20px;
  font-size: 16px;
  margin-top: 10px;
}
.content-one p {
  text-align: left;
}
.set-default {
  color: #1980ff;
  cursor: pointer;
  font-size: 14px;
}
.is-default {
  font-size: 14px;
  cursor: not-allowed;
}
</style>
